// NOTE - this dialog is currently not being used.
// It has been replaced with a dialog that warns the user when
// their session is about to expire.
// If this dialog is used at some point in the future, make sure
// to remove the 'location.reload();' statement below.  The whole
// point of this dialog is to let the user log back in "without" losing
// any work, but having the reload statement will cause a full page
// refresh any any work would be lost.
import * as ko from "knockout";
import * as AuthenticationData from "../data/authenticationData";
import { IApplication } from "../interfaces/application";
import * as Data from "../interfaces/data";
import * as Global from "./global";
import * as UI from "./ui";

// singleton instance of the dialog control
let dialogIsCreated: boolean = false;
let container: JQuery;
let dialog: JQuery;
let viewModel: any = {};

// showDialog
//  display a dialog for the user to reenter their password
//  after a session inactivity timeout.
export function showPasswordDialog(): void {

    if (!dialogIsCreated) {
        // first time being called, bind the events
        render().done(() =>  {
            dialog = container.find(".modal");
            dialogIsCreated = true;

            displayDialog();
        });
    } else {
        displayDialog();
    }
}

function render(): JQueryPromise<any> {
    const app: IApplication = Global.app();
    const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

    viewModel = {
        // login fields
        UserName: ko.observable(""),
        Password: ko.observable(""),
        UserNameMissing: ko.observable(false),
        PasswordMissing: ko.observable(false),
        LoginInvalid: ko.observable(false),
        AccountLocked: ko.observable(false),
        AccountLockedLength: ko.observable(0),

        onLogin(): void {
            processLoginRequest();
        },
        onCancel(): void {
            dialog.modal("hide");
            app.pageManager().logout();
        },
    };

    container = $("<div></div>").appendTo("body");
    app.templates().render("enterpassworddialog", "template_enterpassworddialog", container)
        .done(() =>  {
            ko.applyBindings(viewModel, container[0]);
            deferred.resolve();
        });

    return deferred.promise();
}

function displayDialog(): void {
    viewModel.UserName("");
    viewModel.Password("");
    viewModel.UserNameMissing(false);
    viewModel.PasswordMissing(false);
    viewModel.LoginInvalid(false);
    viewModel.AccountLocked(false);

    dialog.modal("show");
}

function processLoginRequest(): void {
    const app: IApplication = Global.app();
    let waitContainer: JQuery<HTMLElement>;
    let request: AuthenticationData.IAuthenticateUserRequest;

    if (!validateLogin()) {
        setFocusToUserNameField();
        return;
    }

    waitContainer = UI.showWaitIndicator(dialog);

    request = {
        UserName: viewModel.UserName(),
        Password: viewModel.Password(),
    };

    AuthenticationData.AuthenticateUser(request)
        .done((response: Data.IResponse<AuthenticationData.IAuthenticationResponse>) => {
            if (response.Success) {
                if (response.Payload.IsAuthenticated) {
                    // user logged in OK
                    viewModel.LoginInvalid(false);
                    viewModel.AccountLocked(false);
                    // save the user information for use by all other pages
                    app.loginUser(response.Payload.AuthenticationToken, response.Payload.UserSession, response.Payload.ReportToken);

                    dialog.modal("hide");
                    // NOTE - this line should not be here because we do NOT want to full page reset after logging back in
                    location.reload();
                } else {
                    // could not log, check the reason and take action

                    if (response.Payload.MustChangePassword) {
                        // user name/password was OK, but user must change their password
                        dialog.modal("hide");
                        app.router().navigate("/ResetPassword/Expired/" + response.Payload.PasswordResetToken, true);
                    } else if (response.Payload.ExceededMaximumAttempts) {
                        // login has failed maximum number of times, account is now locked
                        viewModel.LoginInvalid(false);
                        viewModel.AccountLocked(true);
                        viewModel.AccountLockedLength(response.Payload.AccountLockedLength);
                    } else {
                        // for all other reasons, let the user retry
                        setFocusToUserNameField();
                        viewModel.LoginInvalid(true);
                        viewModel.AccountLocked(false);
                    }
                }
            } else {
                UI.showErrorMessage(response.ErrorMessages);
            }
        })
        .always(() =>  {
            UI.hideWaitIndicator(dialog, waitContainer);
        });
}

function validateLogin(): boolean {
    let isValid: boolean = true;

    isValid = UI.setRequiredStringError(viewModel.UserName(), "UserNameMissing", viewModel) ? isValid : false;
    isValid = UI.setRequiredStringError(viewModel.Password(), "PasswordMissing", viewModel) ? isValid : false;

    return isValid;
}

function setFocusToUserNameField(): void {
    container.find("input[data-id='loginField']").first().focus();
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/enterPasswordDialog.ts